export const NAME = 'unsubscribe';

export const REQUEST_UNSUBSCRIBE = 'REQUEST_UNSUBSCRIBE';
export const SUCCESS_UNSUBSCRIBE = 'SUCCESS_UNSUBSCRIBE';
export const FAILURE_UNSUBSCRIBE = 'FAILURE_UNSUBSCRIBE';



// WEBPACK FOOTER //
// ./src/services/unsubscribe/constants.js